import { useDebouncedState } from '@sparklayer-io/spark-dash-ui/hooks/use-debounced-state';
import { Input } from '@ui/themed';
import { useEffect, useState } from 'react';

const DEBOUNCE_MS = 300;

/** The search APIs reject terms shorter than this, so anything shorter clears the filter. */
const MIN_SEARCH_LENGTH = 2;

/**
 * Debounced search box. Reports `''` for a term too short to search, so the filter clears
 * rather than leaving stale results under a box that no longer matches them.
 */
export function SearchInput({
  onSearchChange,
  placeholder,
  minLength = MIN_SEARCH_LENGTH,
}: {
  onSearchChange: (value: string) => void;
  placeholder: string;
  minLength?: number;
}) {
  const [value, setValue] = useState('');
  const debouncedValue = useDebouncedState(value, DEBOUNCE_MS);

  useEffect(() => {
    onSearchChange(debouncedValue.length >= minLength ? debouncedValue : '');
  }, [debouncedValue, minLength, onSearchChange]);

  return (
    <div className="max-w-3xs">
      <Input icon="search" placeholder={placeholder} value={value} onChange={setValue} />
    </div>
  );
}
